import styled from 'styled-components';

const EditingSectionWrapperDiv = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  background-color: var(--color-bg-hover);
  border-radius: 4px;
`;

export default EditingSectionWrapperDiv;
